import React, { useState } from "react";
import AnimatedTextInput from "./animatedTextInput";
import AnimatedHiddenTextInput from "./animatedHiddenTextInput";
import { ReactComponent as GreenTick } from "../img/icons/icon_tick_green.svg";
import { useTranslation } from "react-i18next";
import { getIC4ID, parseNumberFromAnotherLocale, parsePID } from "../utils";
import { Checkbox } from "@material-ui/core";

/*
 * NOTE: This component is currently hardcoded to be used for Patient ID input and verification only
 */

function ConfirmTextInput({
  question,
  descriptions = [],
  labelText1,
  labelText2,
  subHeaderText,
  inputResponseText = "",
  onSubmitHandler,
  qKey,
}) {
  const [text, setText] = useState(inputResponseText);
  const [confirmText, setConfirmText] = useState("");
  const [inputType, setInputType] = useState("text");
  const [errorMsg, setErrorMsg] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [doesntHaveID, setDoesntHaveId] = useState(false);

  // console.log(text);
  // console.log(confirmText);
  const { t } = useTranslation();
  const handleInputChange = (e) => {
    setErrorMsg("");
    setText(e.target.value);
  };
  const handleConfirmInputChange = (e) => {
    setErrorMsg("");
    console.log(errorMsg);
    setConfirmText(e.target.value);
  };
  const fetchPIDURL = (patientId) =>
    `/api/v1/users/register/recover/${patientId}`;

  const isIC4ID = (patientId) => {
    const cleanedPID = parsePID(patientId);
    try {
      const parsedPID = parseNumberFromAnotherLocale(cleanedPID);
      return parsedPID.match(/^\d{8}$/) !== null;
    } catch (e) {
      return false;
    }
  };

  const fetchUserDetails = () => {
    if (doesntHaveID) {
      onSubmitHandler({ [qKey]: text }, true);
      return;
    }

    if (isIC4ID(text)) {
      setIsFetching(true);
      fetch(fetchPIDURL(getIC4ID(text)), { method: "GET" })
        .then((response) => response.json())
        .then((responseData) => {
          console.log(responseData);
          if (responseData["status"]["success"]) {
            onSubmitHandler({
              MOBILE: responseData["mobile"],
              EMAIL: {
                email: responseData["email"],
                confirmEmail: responseData["email"],
              },
              "PREF-TREATING-LOC": {
                value: responseData["clinicId"] || "CC000001",
                text: responseData["clinicName"] || "Bhandup",
                disabled: false,
                hasOldPatients: false,
                next: "DOB",
              },
              [qKey]: getIC4ID(text),
            });
          } else {
            if (responseData["status"]["code"] === 4091) {
              setErrorMsg(t("onboard.PID.alreadyExists"));
            } else if (responseData["status"]["code"] === 4003) {
              setErrorMsg(t("onboard.PID.appIdNotFound"));
            } else {
              setErrorMsg(responseData["status"]["message"]);
            }
          }
        })
        .finally(() => setIsFetching(false));
    } else {
      onSubmitHandler({ [qKey]: text });
    }
  };

  const Descriptions = descriptions.map((text, index) => {
    return (
      <p className="desc" key={index}>
        {text}
      </p>
    );
  });

  return (
    <div className="body_content">
      <div className="inner_body ">
        <h3 className="headtitle">{question}</h3>
        {Descriptions}
        <div className="fill_form light_fill_form">
          <AnimatedHiddenTextInput
            label={labelText1}
            id={"textInput"}
            value={doesntHaveID ? "" : text}
            onChange={handleInputChange}
            isDisabled={doesntHaveID}
          />
          <h3 className="headtitle mb-4">{subHeaderText}</h3>

          <fieldset className="field_group field_lbl_active">
            <label htmlFor="password-input" className="field_lbl">
              {labelText2}
            </label>
            <input
              type={inputType}
              onFocus={() => {
                //setErrorMsg("");
                setInputType("text");
              }}
              onBlur={() => setInputType("password")}
              name="password"
              id="password-input"
              className="field_input"
              autoComplete="off"
              disabled={doesntHaveID}
              value={doesntHaveID ? "" : confirmText}
              onChange={handleConfirmInputChange}
            />
            {text && text === confirmText && !doesntHaveID && (
              <span className="icon">
                <GreenTick className="img-fluid" />
              </span>
            )}
          </fieldset>

          {text !== confirmText && confirmText !== "" && !doesntHaveID && (
            <span className="txt_help " style={{ color: "red" }}>
              {t("sidenav.PASSWORD.message5")}
            </span>
          )}
          {errorMsg !== "" && (
            <span className="txt_help " style={{ color: "red" }}>
              {errorMsg}
            </span>
          )}
          <div className="btn_block d-flex justify-content-center bottom_button">
            <button
              className="btn btn_primary nextstep_cta"
              disabled={
                (text !== confirmText || text === "") && doesntHaveID === false
              }
              onClick={() => fetchUserDetails()}
            >
              {isFetching ? (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              ) : (
                <></>
              )}
              {t("login.DOBSTEP.button")}
            </button>
          </div>
        </div>
        <div className="d-flex aligh-items-start">
          <Checkbox
            checked={doesntHaveID}
            disabled={text || confirmText ? true : false}
            onChange={() => setDoesntHaveId((doesntHaveID) => !doesntHaveID)}
            style={{
              height: "fit-content",
              color: doesntHaveID ? "var(--primarycolor)" : "",
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
          <div>
            <div
              style={{
                color: "var(--graycolorfour)",
                fontSize: "var(--fs14)",
                fontFamily: "var(--ffpoppins)",
                lineHeight: "21px",
              }}
            >
              {t("onboard.PID.doesnotHavePID1")}
            </div>
            <div
              style={{
                color: "var(--graycolorfour)",
                fontSize: "var(--fs12)",
                fontFamily: "var(--ffpoppins)",
                lineHeight: "21px",
              }}
            >
              {t("onboard.PID.doesnotHavePID2")}{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmTextInput;
